import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetOcrTradesService } from "@/features/accounts/ocr/services/get-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetOcrTradesResponseModel } from "@/features/accounts/ocr/services/get-trades-model";


export const useGetOcrTrades = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getOcrTradesService = new GetOcrTradesService();
  // OCR明細一覧取得
  const getOcrTrades = async (
    accountGroupId: string,
    ocrAccountId: string,
    startDate?: string,
    endDate?: string,
  ) :Promise<GetOcrTradesResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getOcrTradesService.getOcrTrades({
        account_group_id:  accountGroupId,
        ocr_account_id: ocrAccountId,
        ...(startDate !== undefined && { start_date: startDate }),
        ...(endDate !== undefined && { end_date: endDate }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getFinanceTrades:", error);
      throw error;
      // return [];
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getOcrTrades: errorHandledAsync(getOcrTrades, setError),
  };
};
